/* eslint-disable react/display-name */
import classNames from "classnames";
import React, { forwardRef } from "react";

interface OtpInputProps {
  onChange: (value: string, index: number) => void;
  onPaste?: (e: React.ClipboardEvent) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>, index: number) => void;
  value: string;
  index: number;
  className?: string;
}

export const OtpInput = forwardRef<HTMLInputElement, OtpInputProps>(
  (
    { value, onChange, onPaste, onKeyDown, index, className },
    ref: React.RefObject<HTMLInputElement>
  ) => {
    return (
      <input
        ref={ref}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.value, index)
        }
        value={value}
        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) =>
          onKeyDown?.(event, index)
        }
        onPaste={onPaste}
        type="number"
        pattern="[0-9]*"
        maxLength={1}
        className={classNames(
          "bg-white rounded p-4 text-md w-full text-center mr-2 outline-primary",
          className
        )}
      />
    );
  }
);
